import { useWindowDimensions } from '../context/WindowDimensionsContext';

const ResponsiveLayout = ({ breakPoint = 700, renderMobile, renderDesktop }) => {
  const { width } = useWindowDimensions();
  return width > breakPoint ? renderDesktop : renderMobile;
}

export default ResponsiveLayout
